import { stringify } from 'query-string'
import { API_BI_BASE_URL, API_TIMEOUT } from 'shared/constants/defaultENV'

import { Api } from './ApiGlobals'

const BiApi = new Api({
  baseURL: API_BI_BASE_URL,
  timeout: API_TIMEOUT,
})

BiApi.instance.defaults.paramsSerializer = function (params) {
  return stringify(params)
}

export default BiApi
